<script>
  import { DateTime } from 'luxon'

  import { reportHistory$ } from '../store.js'
  import { formatDate, formatTime } from '../views/helpers'

  import LoadingIndicator from '../components/LoadingIndicator.svelte'

  // 表示する列
  const columns = [
    '報告者名',
    '会社名',
    '工事名',
    '作業内容',
    '開始時刻',
    '終了時刻',
    'メンバー',
    '人数',
  ]

  // フォーマッタの割り当て
  const formatters = {
    開始時刻: formatTime,
    終了時刻: formatTime,
  }

  // 列表示のフォーマット
  const formatColumn = (key, value) =>
    // フォーマッタ割り当てがある場合はフォーマットし、そうではないならそのままを返す
    formatters[key] ? formatters[key](value) : value

  // サマライズ
  const summarize = (reports) =>
    Object.entries(
      // 日付ごとにまとめる
      reports.reduce((acc, cur) => {
        // キーが日付、バリューが行データの配列
        acc[cur['日付']] = acc[cur['日付']] ? [...acc[cur['日付']], cur] : [cur]
        return acc
      }, {})
    )
      // 日付でソート
      .sort(([lastDate], [currentDate]) =>
        DateTime.fromFormat(lastDate, 'yyyy/MM/dd').diff(
          DateTime.fromFormat(currentDate, 'yyyy/MM/dd')
        )
      )

  // 日報のサマリ
  $: summary = $reportHistory$ ? summarize($reportHistory$) : undefined
</script>

<h1>作業日報 サマリ</h1>

<!-- 表テーブル -->
{#if summary}
  {#each summary as [date, reports], i}
    <details data-testid={`details-${i}`}>
      <summary class="panel-heading" data-testid={`summary-${i}`}>
        {formatDate(date)}
        {reports.reduce((acc, cur) => acc + Number(cur['人数']), 0)}名
      </summary>

      <table class="table is-striped is-hoverable">
        <!-- ヘッダ -->
        <thead>
          <tr>
            {#each columns as header}
              <th>{header}</th>
            {/each}
          </tr>
        </thead>

        <!-- データ行 -->
        <tbody>
          {#each reports as report, j}
            <tr data-testid={`row-${i}-${j}`}>
              {#each columns as key}
                <td>{report[key] ? formatColumn(key, report[key]) : ''}</td>
              {/each}
            </tr>
          {/each}
        </tbody>
      </table>
    </details>
  {/each}
{:else}
  <LoadingIndicator />
{/if}
